import { css } from 'styled-components';

import { type ObjectValuesUnionType } from '../../../utils/typing';

export const GapDirections = Object.freeze({
  NORMAL: 'right',
  REVERSE: 'left',
});

export type GapDirection = ObjectValuesUnionType<typeof GapDirections>;

export default (length: number, unit: string = 'em', direction: GapDirection = GapDirections.NORMAL) => {
  const extremity = direction === GapDirections.NORMAL ? 'last' : 'first';
  return css`
    & > * {
      margin-${direction}: ${'' + length + unit};
      &:${extremity}-child {
        margin-${direction}: ${'' + 0 + unit};
      }
    }
  `;
};
